import DashboardIcon from "../assets/svg/dashboard-menu-new.svg";
import CommitteePageIcon from "../assets/svg/committee-pages.svg";
import MemberIcon from "../assets/svg/member.svg";
import MasterIcon from "../assets/svg/master-icon.svg";
import CommitteeIcon from "../assets/svg/committee.svg";
import PublicEventIcon from "../assets/svg/public-events.svg";
import HomePageIntegrateIcon from "../assets/svg/homepage-integrate-icon.svg";
import MenuIcon from "../assets/svg/menu-icon.svg";
import ReportIcon from "../assets/svg/reports-menu-icon.svg";
import LoginReportIcon from "../assets/svg/login-report-icon.svg";
import MemberReportIcon from "../assets/svg/member-report-icon.svg";

export const getMenu = () => {
  const role = Number(sessionStorage.getItem("userRoleID")); // always fresh
  return [
    {
      path: "/Admin/dashboard",
      img: DashboardIcon,
      title: "Dashboard",
    },
    ...(role === 3
      ? [
          {
            path: "/Admin/Committee",
            img: MasterIcon,
            title: "Masters",
            children: [
              {
                path: "/Admin/Committee",
                title: "Committees",
                img: CommitteeIcon,
              },
              { path: "/Admin/Member", title: "Members", img: MemberIcon },
              { path: "/Admin/Menu", title: "Menu", img: MenuIcon },
            ],
          },

          {
            path: "/Admin/HomePage",
            img: HomePageIntegrateIcon,
            title: "Home Page",
          },
        ]
      : []),
    {
      path: "/Admin/CommitteePage",
      img: CommitteePageIcon,
      title: "Committee Pages",
    },
    {
      path: "/Admin/PublicEvents",
      img: PublicEventIcon,
      title: "Public Events",
    },
    {
      path: "Report/Membership",
      img: ReportIcon,
      title: "Reports",
      children: [
        {
          path: "/Admin/Report/Membership",
          title: "Membership Report",
          img: MemberReportIcon,
        },
        {
          path: "/Admin/Report/Login",
          title: "Login Report",
          img: LoginReportIcon,
        },
      ],
    },
  ];
};
